import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { fetchSiteSettings } from "../lib/wordpressApi";

// Default values (fallback if API fails)
const defaultSettings = {
  email: "enquiry@thelinguaalliance.com",
  phone: "+91 90498 30590",
  whatsapp: "+919049830590",
  address:
    "Office 603, Navale Icon, Near Navale Bridge, Mumbai-Banglore Express way, Narhe Pune 411041.",
  facebook: "https://www.facebook.com/profile.php?id=61583176468896",
  instagram: "https://www.instagram.com/the_lingua_alliance/",
  linkedin: "https://www.linkedin.com/company/the-lingua-alliance/",
  youtube: "https://www.youtube.com/@TheLinguaAlliance",
};

const SiteSettingsContext = createContext({
  settings: defaultSettings,
  loading: true,
  error: null,
  refetch: () => {},
});

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadSettings = useCallback(async (useCache = true) => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchSiteSettings(useCache);
      setSettings(data);
    } catch (err) {
      console.error("Failed to load site settings:", err);
      setError(err.message);
      // Keep default settings on error
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const refetch = useCallback(() => {
    loadSettings(false);
  }, [loadSettings]);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, error, refetch }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error("useSiteSettings must be used within a SiteSettingsProvider");
  }
  return context;
};

export default SiteSettingsContext;
